import { useParams, useSearchParams } from "react-router-dom";
import { Suspense, lazy, useEffect } from "react";
import { light } from "shared/constants/themes";
import { getEnvAndBrand } from "shared/utils";
import { widgetsToPathMap } from "shared/constants";
import Loader from "shared/components/common/Loader";
import { useDeviceStore } from "shared/stores/deviceStore";
import { useSharedStore } from "shared/stores/sharedStore";
import NotFoundPage from "shared/components/common/NotFoundPage";

export const DynamicWidgetLayout = () => {
  const updateIsMobile = useDeviceStore((state) => state.updateIsMobile);
  const updateBrand = useSharedStore((state) => state.updateBrand);
  // const updateHost = useSharedStore((state) => state.updateHost);
  const isMobile = useDeviceStore((state) => state.isMobile);
  const [searchParams] = useSearchParams();

  const theme = searchParams.get("theme") ?? light;
  const { environment, brand } = getEnvAndBrand();

  const { widget } = useParams<{
    widget: string;
  }>();

  useEffect(() => {
    function handleResize() {
      updateIsMobile(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    // Initial check
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [updateIsMobile]);

  if (
    environment.toLowerCase() !== import.meta.env.VITE_NODE_ENV.toLowerCase() &&
    import.meta.env.VITE_NODE_ENV !== "development"
  ) {
    return (
      <div style={{ color: "red", fontWeight: "bold" }}>
        The current domain ({environment}) does not match the environment (
        {import.meta.env.VITE_NODE_ENV}). Access restricted.
      </div>
    );
  }

  if (!brand || !widget) return <NotFoundPage />;

  updateBrand(brand);
  const DynamicWidget = widgetsToPathMap[widget.toLocaleLowerCase()];
  const dataTheme = `${brand}-${theme}`;

  if (!DynamicWidget) {
    return <NotFoundPage dataTheme={dataTheme} />;
  }

  const LazyDynamicWidget = lazy(DynamicWidget);

  return (
    <div
      className="app"
      data-theme={dataTheme}
      data-ismobile={isMobile} // for css
    >
      <Suspense
        fallback={<Loader isTransparent={true} transparentBackground={true} />}
      >
        <LazyDynamicWidget />
      </Suspense>
    </div>
  );
};
